module.exports = __webpack_public_path__ + "static/media/new-york-16.a96a144e.jpg";